<!-- Displays all documents related to a particular tab in the list of categories.-->

<template>
  <mdb-card v-if="!loading" class="mt-2 mb-3 animated bounce">
    <mdb-card-header>
      <strong>Documents</strong>
    </mdb-card-header>
    <mdb-card-body v-if="!loading">
      <mdb-card-text>
        <tree v-if="!loading" class="item" :depth="-1" :item="documents"></tree>
      </mdb-card-text>
    </mdb-card-body>
  </mdb-card>
</template>

<script>
import { mdbCard, mdbCardBody, mdbCardHeader, mdbCardText } from "mdbvue";
import tree from "@/views/departments/documents/DocumentTreeView.vue";
export default {
  name: "DepartmentDocumentTabView",
  components: {
    mdbCard,
    mdbCardBody,
    mdbCardHeader,
    mdbCardText,
    tree,
  },
  props: {
    type: {
      type: [String],
      default: "departments.DepartmentTabPage",
    },
    fields: {
      type: [String],
      default:
        "title,content,categories,tags,blog_authors,custom_title,banner_image,parent_id",
    },
    documents: {
      type: [Array, Object],
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    newNodes() {
      var something = {
        name: "djflksdf",
        documents: this.documents,
      };
      return something;
    },
  },
  watch: {
    documents: function () {
      this.loading = true;
      process.nextTick(
        function () {
          this.loading = false;
        }.bind(this)
      );
    },
  },
};
</script>
